export type MinimumInvestorPortfolioSizeWarningParams = {
  minimumInvestorPortfolioSize: number;
  dealSharePrice: number;
  defaultTransactionFeePercent: number;
  initialTargetShares: number;
  lowestInvestmentCapitalInSelection: number;
  defaultTransactionFeeVatPercent: number;
};

export type MinimumInvestorPortfolioSizeWarningResult = {
  shouldShowWarning: boolean;
  portfolioAllocationPercent: number;
};

const getMinimumInvestorPortfolioSizeWarning = (
  params: MinimumInvestorPortfolioSizeWarningParams,
): MinimumInvestorPortfolioSizeWarningResult => {
  const {
    minimumInvestorPortfolioSize,
    dealSharePrice,
    defaultTransactionFeePercent,
    defaultTransactionFeeVatPercent,
    initialTargetShares,
    lowestInvestmentCapitalInSelection,
  } = params;

  const transactionFeeMultiplier =
    1 +
    (defaultTransactionFeePercent +
      defaultTransactionFeePercent * (defaultTransactionFeeVatPercent / 100)) /
      100;
  const sharePriceWithFee = dealSharePrice * transactionFeeMultiplier;

  const portfolioAllocationPercent =
    minimumInvestorPortfolioSize > 0 ? 100 / minimumInvestorPortfolioSize : 0;

  const shouldShowWarning =
    minimumInvestorPortfolioSize > 0 &&
    initialTargetShares > 0 &&
    lowestInvestmentCapitalInSelection > 0 &&
    sharePriceWithFee >
      lowestInvestmentCapitalInSelection / minimumInvestorPortfolioSize;

  return { shouldShowWarning, portfolioAllocationPercent };
};

export default getMinimumInvestorPortfolioSizeWarning;
